<template lang="html">
    <section class="shades col-md-12">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-xs-12 shades-searchBar"><div class="shades-searchBar-menu">-------</div></div>
            <div class="col-lg-9 col-md-9 col-xs-12 shades-list">
                <div class="shades-list-items row">
                    <div class="result" v-if="getShades.meta">
                        <p class="resultText" v-html-safe="$t('shades.msgResultSearch').replace('{result}', getShades.meta.total)"></p>
                    </div>
                    <div class="shades-list-pagination" v-if="getShades.meta">
                        <Pagination :componentName="'Shades'" :meta="getShades.meta" :page="currentPage"></Pagination>
                    </div>
                    <ListShades :dataShades="getShades.data" :isLoader="loader"></ListShades>
                    <div class="shades-list-pagination" v-if="getShades.meta">
                        <Pagination :componentName="'Shades'" :meta="getShades.meta" :page="currentPage"></Pagination>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
    import { mapActions, mapGetters } from "vuex"
    import ListShades from "./listShades"
    import Pagination from "./pagination"
  export default  {
    name: 'shades',
    props: [],
      components: {
          ListShades,
          Pagination
      },
    data() {
      return {
          currentPage: null,
          loader: true
      }
    },
    watch: {
      $route(to, from) {
          this.currentPage = this.$route.query.offset;
          this.loader = true;
          this.getListeShades(20, to.query.search, "desc", to.query.offset).then(() => {
              this.loader = false;
          })
      }
    },
    methods: {
        ...mapActions({
            getShadesAction: "shades/getShadesAction"
        }),
        getListeShades(limit = 20, search = "", order = "desc", offset = 1) {
            return this.getShadesAction("limit=" + limit + "&search=" +search + "&order=" + order +"&offset=" + offset)
        }
    },
    computed: {
      ...mapGetters({
          getShades: "shades/getShades"
      })
    },
    created() {
        this.getListeShades(20, this.$route.query.search, "desc", this.$route.query.offset).then(() => {
            this.loader = false;
        })
    }
}
</script>

<style scoped lang="scss">
.shades {
    &-searchBar {
        &-menu {
            background: white;
            padding: 25px;
            .dark & {
                background-color: #111111;
                border: 1px #686868 solid;
            }
        }
    }
    &-list {
        &-items {
            background: white;
            padding: 25px;
            .dark & {
                background-color: #111111;
                border: 1px #686868 solid;
            }
            .result {
                width: 100%;
                .resultText {
                    font-size: 16px;
                    font-weight: bold;
                    font-family: "oswald-regular", sans-serif;
                    margin: 0;
                    span {
                        color: red;
                    }
                    .dark & {
                        color: white;
                    }
                }
            }
        }
        &-pagination {
            text-align: right;
            width: 100%;
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Shades.vue?22780a70